<mat-sidenav-container class="layout" autosize>
  <mat-sidenav
    #drawer
    [mode]="isMobile() ? 'over' : 'side'"
    [disableClose]="!isMobile()"
    class="sidenav"
  >
    <div class="no-scroll">
      <div class="logo-container">
        <div class="logo-title">HCI</div>
        <div class="logo-subtitle">Backoffice</div>
      </div>

      @if (userFullName()) {
        <div class="texto-usuario pt-3">Hola, {{ userFullName() }}</div>
      }
      @if (roleLabel()) {
        <div class="texto-usuario line-separator">Rol: {{ roleLabel() }}</div>
      }
      <div class="divider"></div>

      <nav>
        <ng-container *ngFor="let item of menu">
          <!-- Sección -->
          <div class="section-title" *ngIf="hasVisibleChildren(item)">
            {{ item.label }}
          </div>

          <!-- Items de sección -->
          <ng-container *ngIf="hasVisibleChildren(item)">
            <ng-container *ngFor="let child of item.children">
              <div class="menu-item" *ngIf="isVisible(child)" (click)="navigate(child)">
                <mat-icon>{{ child.icon }}</mat-icon>
                <span>{{ child.label }}</span>
              </div>
            </ng-container>
          </ng-container>

          <!-- Item simple (logout) -->
          <div class="menu-item logout" *ngIf="!item.children" (click)="navigate(item)">
            <mat-icon>{{ item.icon }}</mat-icon>
            <span>{{ item.label }}</span>
          </div>
        </ng-container>
      </nav>
    </div>
  </mat-sidenav>

  <mat-sidenav-content>
    <button
      mat-icon-button
      class="menu-btn"
      *ngIf="isMobile()"
      (click)="toggleSidebar()"
      aria-label="Abrir menú de navegación"
    >
      <mat-icon>menu</mat-icon>
    </button>

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
